import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompass = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M18.6393 4.9904L18.644 4.97464C18.6842 4.82068 18.6763 4.65809 18.6212 4.50879C18.5662 4.35949 18.4666 4.23066 18.3361 4.13969C18.2055 4.04871 18.0502 3.99995 17.8911 4C17.732 4.00005 17.5767 4.04889 17.4462 4.13994L17.4405 4.14372L5.52801 13.4427L5.51603 13.4528C5.42719 13.5314 5.36706 13.6374 5.34514 13.754C5.32321 13.8706 5.34074 13.9911 5.39494 14.0967C5.44915 14.2022 5.53696 14.2867 5.6445 14.3367C5.75205 14.3868 5.87321 14.3997 5.98886 14.3732L11.7337 13.0336C11.8025 13.0176 11.8738 13.0162 11.9432 13.0295C12.0125 13.0428 12.0782 13.0705 12.1362 13.1108C12.1941 13.1511 12.2429 13.2032 12.2795 13.2635C12.3161 13.3239 12.3395 13.3913 12.3484 13.4613L12.8821 19.1577V19.164C12.8948 19.2828 12.9476 19.3938 13.0319 19.4786C13.1161 19.5634 13.2267 19.617 13.3455 19.6305C13.4637 19.6459 13.5837 19.6209 13.686 19.5597C13.7883 19.4985 13.867 19.4046 13.9094 19.2932L13.9116 19.2872L18.6393 4.9904Z" })]
});
const ForwardRef = forwardRef(SvgCompass);
export { ForwardRef as ReactComponent };
